import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function LoanRecordsScreen() {
  return <PlaceholderScreen title="Loan Records" />
}